"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sectionStyles = exports.sectionHeaderStyles = exports.SectionWrapper = exports.SectionHeader = exports.DisabledTitle = void 0;
var _mui = require("@ori-ui/mui");
const sectionStyles = (theme)=>({
        background: theme.palette.background.paper,
        padding: theme.spacing(4, 3),
        marginBottom: theme.spacing(4),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4, 6),
            borderRadius: theme.spacing(2)
        }
    });
exports.sectionStyles = sectionStyles;
const sectionHeaderStyles = ()=>({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: 40
    });
exports.sectionHeaderStyles = sectionHeaderStyles;
const SectionWrapper = exports.SectionWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...sectionStyles(theme)
    };
});
const SectionHeader = exports.SectionHeader = (0, _mui.styled)('div')({
    ...sectionHeaderStyles()
});
const DisabledTitle = exports.DisabledTitle = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.default.light
    };
});
